import React, { useState } from 'react'
import { ContentfulDownloadButton } from '../BlockLibrary/ContentfulDownloadButton';
import { RichText } from '../richTextOptions';
import { Image } from '../BlockLibrary/Common/Image';

const ContentfulBlockTextDownloadTemplate = ({ text, withButton }) => {
	return (
		<div className={"claim-step " + (!withButton ? ' step2 ' : '')}>
			<Image image={text.optionalIcon} />
			<div className="claim-step-text">
				<RichText data={text.richText}></RichText>
				{
					withButton == true && (
						<ContentfulDownloadButton></ContentfulDownloadButton>
					)
				}
			</div>
		</div>
	);
}

const ContentfulBlockTextDefault = ({ text }) => {
	if (text.backgroundColor) {
		return (
			<div className="banner-content" style={{ backgroundColor: text.backgroundColor }}>
				<RichText data={text.richText}></RichText>
			</div>
		)
	}

	return <RichText data={text.richText}></RichText>
}

const ContentfulBlockTextNoteAboveFooter = ({ text }) => {
	return (
		<div className="note-above-footer">
			<div className="container">
				<div className="content-wrapper">
					<RichText data={text.richText}></RichText>
				</div>
			</div>
		</div>
	)
}

const ContentfulBlockTextLogoInline = ({ text }) => {
	// console.log(text)
	return (
		<div className="logo-inline-wrapper">
			<div className="logo-inline">
				<div className="logo">
					<Image image={text.optionalIcon} />
				</div>
				<div className="headline" dangerouslySetInnerHTML={{ __html: text.textInlineSvg.childMarkdownRemark ? text.textInlineSvg.childMarkdownRemark.html : text.textInlineSvg }}></div>
			</div>
			<div className="logo-inline-content">
				<RichText data={text.richText}></RichText>
			</div>
		</div>
	)
}

const ContentfulBlockLogoWithText = ({ text }) => {
	// console.log(text)
	return (
		<div className="logo-with-text-wrapper">
			<div className="logo">
				<Image image={text.optionalIcon} />
			</div>
			<div className="content">
				<RichText data={text.richText}></RichText>
			</div>
		</div>
	)
}

const ContentfulBlockTextTemplate = ({ text }) => {
	const className = text.template.replace(/ /g, '-').toLowerCase();
	return (
		<div className={className}>
			<RichText data={text.richText}></RichText>
		</div>
	)
}

const ContentfulBlockTextProTip = ({ text }) => {
	const className = text.template.replace(/ /g, '-').toLowerCase();
	return (
		<div className={className} style={{ backgroundImage: text.optionalIcon ? 'url(' + text.optionalIcon?.file?.url + ')' : null }}>
			<RichText data={text.richText}></RichText>
		</div>
	)
}

const ContentfulBlockListAnchorMobile = ({ text }) => {
	return (
		<div className="list-anchor-wrapper">
			<div className="is-mobile">
				<div className="select-box">
					<div className="headline-select">Jump to questions about:</div>
					<div className="select-text">
						<button>Select one</button>
						<div className={`arrow-down`}></div>
					</div>
					<div className="list-select-wrapper">
						<div className="wrapper">
							<div className="list-select list-anchor">
								<RichText data={text.richText}></RichText>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	)
}

const ContentfulBlockText = text => {
	var content = '';
	switch (text.template) {
		case 'DownloadStep':
			content = <ContentfulBlockTextDownloadTemplate withButton={false} text={text}></ContentfulBlockTextDownloadTemplate>
			break;
		case 'DownloadStepWithButton':
			content = <ContentfulBlockTextDownloadTemplate withButton={true} text={text}></ContentfulBlockTextDownloadTemplate>
			break;
		case 'NoteAboveFooter':
			content = <ContentfulBlockTextNoteAboveFooter text={text}></ContentfulBlockTextNoteAboveFooter>
			break;
		case 'LogoInline':
			content = <ContentfulBlockTextLogoInline text={text} ></ContentfulBlockTextLogoInline>
			break;
		case 'Headline':
		case 'Description':
		case 'Note Text':
		case 'List Anchor':
		case 'List Checkmark 3 col':
		case 'List Checkmark 5 col':
			content = <ContentfulBlockTextTemplate text={text} ></ContentfulBlockTextTemplate>
			break;
		case 'Pro Tip':
			content = <ContentfulBlockTextProTip text={text} ></ContentfulBlockTextProTip>
			break;
		case 'List Anchor Mobile':
			content = <ContentfulBlockListAnchorMobile text={text} />
			break;
		case 'Logo With Text':
			content = <ContentfulBlockLogoWithText text={text} />
			break;
		default:
			content = <ContentfulBlockTextDefault text={text}></ContentfulBlockTextDefault>;
			break;
	}

	return (
		<>
			{content}
		</>
	)
}

export { ContentfulBlockText }
